module.exports = __webpack_public_path__ + "img/shoplus_logo.06bb1b79.jpg";